import { createStore } from 'store-utils';
import { PolicySettingCategory } from '../policy-settings-types';

const PolicySettingsStore = createStore<PolicySettingsState>(
  {
    policySettings: [],
    isLoading: false,
  },
  'Policy Settings Store',
);

export interface PolicySettingsState {
  policySettings: PolicySettingCategory[];
  isLoading: boolean;
}

export default PolicySettingsStore;
